export const FAQItems = [
  {
    id: 1,
    question: 'New to TikTok? How to get good results from promotion?',
    answer:
      '1. Spend time exploring TikTok to understand its trends and styles. Knowing how the platform works will help your promotion.',
    answer2:
      '2. Create simple, easy-to-repeat tasks for influencers. Get inspired by other successful artists on TikTok.',
    answer3:
      '3. Choose a launch date for your promotion during setup. Continuously refine your strategy and plan your next campaign in 1-2 months.',
    name: 'new_to_tiktok',
  },
  {
    id: 2,
    question: "Should creators' videos match your track's lyrics?",
    answer:
      'Not necessary! Let creators unleash their creativity. This opens up exciting opportunities for your music to shine in various engaging content.',
    name: 'creators_match_lyrics',
  },
  {
    id: 3,
    question: 'Why pick TikTok for promoting your music? ',
    answer:
      '\u2022 Affordable Promotion: TikTok is a budget-friendly platform for upcoming artists to promote their music.',
    answer2:
      '\u2022 Broader Audience: Partnering with TikTok influencers exposes your music to new listeners, helping you connect with more fans.',
    answer3:
      '\u2022 Diverse Content: When various TikTok users interpret your music in unique ways, it showcases its adaptability.',
    name: 'why_tiktok_promoting',
  },
  {
    id: 4,
    question: 'Is your track or genre a good fit for TikTok`s audience?',
    answer:
      'Don`t worry about the genre! Focus on creating easy-to-repeat tasks. TikTok users love short and simple content.',
    name: 'tiktok_good_fit',
  },
  {
    id: 5,
    question: 'How can you find out if your track is on TikTok?',
    answer:
      'Check with your digital distributor to see if your track is already on TikTok:',
    answer3: [
      '\u2022 If yes, use this',
      'instruction',
      'to find your track and start your promotion.',
    ],
    answer4:
      '\u2022 If no, arrange for your distributor to deliver the track to TikTok.',
    name: 'find_track',
  },
]
